
import { Product, Category } from './types';

export const CATEGORIES: Category[] = [
  { id: '1', name: 'Home & Kitchen', image: 'https://picsum.photos/seed/home/600/400', icon: '🏠' },
  { id: '2', name: 'Grocery & Gourmet', image: 'https://picsum.photos/seed/grocery/600/400', icon: '🍎' },
  { id: '3', name: 'Health & Household', image: 'https://picsum.photos/seed/health/600/400', icon: '💊' },
  { id: '4', name: 'Office Products', image: 'https://picsum.photos/seed/office/600/400', icon: '📎' },
  { id: '5', name: 'Pet Supplies', image: 'https://picsum.photos/seed/pets/600/400', icon: '🐾' },
];

export const PRODUCTS: Product[] = [
  {
    id: 'p1',
    name: 'Ergonomic Mesh Office Chair',
    description: 'Advanced lumbar support with high-density foam and breathable mesh back.',
    price: 249.99,
    originalPrice: 299.99,
    rating: 4.8,
    reviews: 124,
    category: 'Office Products',
    images: ['https://picsum.photos/seed/chair1/800/800', 'https://picsum.photos/seed/chair2/800/800'],
    isFeatured: true,
    stock: 15,
    specs: { 'Material': 'Breathable Mesh', 'Warranty': '5 Years', 'Adjustable': 'Yes' },
    variants: [
      { id: 'v1', name: 'Color', options: ['Black', 'Grey', 'Blue'] },
      { id: 'v2', name: 'Size', options: ['Standard', 'XL'] }
    ],
    reviewsList: [
      { id: 'r1', user: 'Alex Rivera', rating: 5, comment: 'Life changer for my back pain! Highly recommended.', date: '2024-03-15' },
      { id: 'r2', user: 'Jordan Smith', rating: 4, comment: 'Solid chair, assembly was a bit tricky but worth it.', date: '2024-02-28' }
    ]
  },
  {
    id: 'p2',
    name: 'Organic Espresso Whole Bean',
    description: 'Slow-roasted, high-altitude arabica beans from fair trade farms in Ethiopia.',
    price: 18.50,
    rating: 4.9,
    reviews: 850,
    category: 'Grocery & Gourmet',
    images: ['https://picsum.photos/seed/coffee/800/800'],
    isNew: true,
    stock: 100,
    specs: { 'Origin': 'Ethiopia', 'Roast': 'Dark', 'Weight': '1kg' },
    reviewsList: [
      { id: 'r3', user: 'Elena G.', rating: 5, comment: 'Smells amazing and the taste is so smooth.', date: '2024-04-01' }
    ]
  },
  {
    id: 'p3',
    name: 'Smart Kitchen Blender Pro',
    description: '1500W motor with intuitive touch controls and auto-clean function.',
    price: 129.00,
    originalPrice: 159.00,
    rating: 4.6,
    reviews: 432,
    category: 'Home & Kitchen',
    images: ['https://picsum.photos/seed/blender/800/800'],
    isFeatured: true,
    stock: 8,
    specs: { 'Power': '1500W', 'BPA Free': 'Yes', 'Capacity': '2L' },
    reviewsList: [
      { id: 'r4', user: 'Marco Polo', rating: 4, comment: 'Very powerful, slightly loud but blends everything perfectly.', date: '2024-03-10' }
    ]
  },
  {
    id: 'p4',
    name: 'Wireless Noise Cancelling Headphones',
    description: 'Premium sound quality with 40-hour battery life and fast charging.',
    price: 199.99,
    rating: 4.7,
    reviews: 210,
    category: 'Electronics',
    images: ['https://picsum.photos/seed/headphones/800/800'],
    stock: 25,
    specs: { 'Bluetooth': '5.2', 'Battery': '40h', 'Type': 'Over-ear' },
    variants: [
      { id: 'v3', name: 'Color', options: ['Midnight Black', 'Silver', 'Rose Gold'] }
    ],
    reviewsList: [
      { id: 'r5', user: 'Zoe Vance', rating: 5, comment: 'The noise cancellation is spooky good. Better than the more expensive brands.', date: '2024-01-20' }
    ]
  },
  {
    id: 'p5',
    name: 'Multi-Vitamin Daily Pack',
    description: 'Complete nutritional support for active adults with essential minerals.',
    price: 34.99,
    rating: 4.5,
    reviews: 1560,
    category: 'Health & Household',
    images: ['https://picsum.photos/seed/vitamins/800/800'],
    stock: 50,
    specs: { 'Quantity': '30 Day Supply', 'Gluten Free': 'Yes' },
    reviewsList: [
      { id: 'r6', user: 'Derek M.', rating: 5, comment: 'Feeling much more energetic after two weeks of use.', date: '2024-03-25' }
    ]
  },
  {
    id: 'p6',
    name: 'Premium Leather Journal',
    description: 'Handcrafted genuine leather notebook with acid-free archival paper.',
    price: 45.00,
    rating: 4.9,
    reviews: 89,
    category: 'Office Products',
    images: ['https://picsum.photos/seed/journal/800/800'],
    isNew: true,
    stock: 12,
    specs: { 'Material': 'Full Grain Leather', 'Pages': '200' },
    reviewsList: [
      { id: 'r7', user: 'Lydia T.', rating: 5, comment: 'The leather feels so high quality. Perfect for my daily sketches.', date: '2024-04-05' }
    ]
  }
];
